import { defineStore } from 'pinia'
import SecureLS from 'secure-ls'
const ls = new SecureLS({ encodingType: 'aes' })

export const useStore = defineStore('store', {
  state: () => ({
    messages: [],   // Массив сообщений
    loadings: [], // ключи по кот идет загрузка
    params: {},
    theme: 'dark',
  }),

  getters: {
    getP: (state) => (key, default_ = null) => {
      return key in state.params ? state.params[key] : default_
    },
    isLoading: (state) => (key) => {
      return key ? state.loadings?.includes(key) : state.loadings?.length > 0;
    },
    isLoadingAny(state) {
      return state.loadings?.length > 0 ?? false;
    },
    isDarkTheme(state) {
      return state.theme === 'dark'
    },
    getMessages(state) {
      return state.messages
    },
    getLoadings(state) {
      return state.loadings
    },
  },

  actions: {
    setP(key, data) {
      this.params[key] = data
    },
    deleteP(key) {
      if (key in this.params) delete  this.params[key]
    },
    addMessage(message) {
      this.messages.push(message)
    },
    deleteMessage(index) {
      this.messages.splice(index, 1)
    },
    clearMessages() {
      this.messages = []
    },
    setLoading(key) {
      if (!this.loadings.includes(key)) this.loadings.push(key)
    },
    setLoaded(key) {
      if (!key) this.loadings = []
      else if (this.loadings.includes(key)) this.loadings = this.loadings.filter(item => item !== key)
      // else console.log(`${key} not found`)

    },
    toggleTheme() {
      this.theme = this.theme === 'dark' ? 'light' : 'dark'
      this.applyTheme()
    },
    applyTheme() {
      const html = document.documentElement
      html.classList.remove('light', 'dark')
      html.classList.add(this.theme)
      html.setAttribute('data-bs-theme', this.theme)
    },
  },

  // persist: true
  persist: {
    storage: {
      getItem: (key) => {
        try {
          return ls.get(key)
        } catch (e) {
          console.warn('secure-ls getItem error:', e)
          return null
        }
      },
      setItem: (key, value) => {
        try {
          ls.set(key, value)
        } catch (e) {
          console.warn('secure-ls setItem error:', e)
        }
      },
      removeItem: (key) => {
        ls.remove(key)
      }
    }
  }


})